import { BaseEditorState, Exchange, TradingPair } from "./common.types"

const allHistoricalPricesPeriods = ["monthly", "daily", "weekly"] as const

export type HistoricalPricesPeriod =
  | typeof allHistoricalPricesPeriods[number]
  | never

export const HistoricalPricesPeriod = {
  /** List of all valid historical periods for the historical price API */
  all: allHistoricalPricesPeriods
}

const historicalYears = [2018, 2019, 2020] as const

/** Valid years for the historical API */
export type HistoricalAPIYear = typeof historicalYears[number]
export const HistoricalAPIYear = {
  all: historicalYears
}

/** Editor state when editing requests meant for the historical API */
export interface HistoricalEditorState extends BaseEditorState<"historical"> {
  year: HistoricalAPIYear
  exchange: Exchange
  symbol: TradingPair
  period: HistoricalPricesPeriod
}

export const HistoricalEditorState = {
  /** Converts an editor state to a REST path we can send a request to  */
  getPath: (state: HistoricalEditorState): string =>
    `/historical/v0/${state.exchange}/${state.symbol}/${state.year}/${state.period}`
}

/** Given an invoice, returns the default editor state for each channel */
export const DefaultHistoricalRequest: HistoricalEditorState = {
  api: "historical",
  exchange: "binance",
  period: "daily",
  symbol: "BTCUSDT",
  year: 2018
}
